import logo from "@globals/img/logo.svg";
import logo_canteen from "@globals/img/logo_canteen.png";
import logo_eurest from "@globals/img/logo_eurest.svg";

enum OperatorSlugs {
  cca = "Canteen",
  eur = "Eurest",
}

type OperatorLogoProps = {
  src: string;
  alt: string;
};

export const getOperatorLogo = (
  operatorSlug: string | null
): OperatorLogoProps => {
  switch (operatorSlug) {
    case "cca":
      return {src: logo_canteen, alt: OperatorSlugs.cca};
    case "eur":
      return {src: logo_eurest, alt: OperatorSlugs.eur};
    default:
      return {src: logo, alt: "EAT Club"};
  }
};
